import { IAppRequest } from '@app/app.interface';
import { AppService } from '@app/app.service';
import { Observable } from 'rxjs';
import { ITableButtons } from './table.interface';

export abstract class TableService extends AppService {
    /** Кнопки для таблицы */
    buttons: ITableButtons = { global: [], globalMenu: [], local: [] };

    /** Наименование доступа для проверки */
    accessName: string = '';

    /** Имя сервиса */
    className: string = '';

    /** Урл к контроллеру */
    url: string = '';

    /**
     * Получение данных для таблицы
     * @param data данные
     */
    public getLists(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/fetch_table_data', data, this._httpOptions);
    }

    /**
     * Получение настроек таблицы
     * @param data данные
     */
    public getTableSettings(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/fetch_table_settings', data, this._httpOptions);
    }

    /**
     * Сохранение настроек таблицы
     * @param data данные
     */
    public saveTableSettings(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/save_table_settings', data, this._httpOptions);
    }

    /**
     * Очистка настроек таблицы
     * @param data данные
     */
    public clearTableSettings(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/clear_table_settings', data, this._httpOptions);
    }

    /**
     * Удаление записей
     * @param data данные
     */
    public remove(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/delete', data, this._httpOptions);
    }

    /**
     * Получение записи
     * @param data данные
     */
    public getItem(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/get_item', data, this._httpOptions);
    }

    /**
     * Сохранение записи
     * @param data данные
     */
    public saveItem(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/save', data, this._httpOptions);
    }

    /**
     * Создание новой записи
     * @param data данные
     */
    public create(data: any): Observable<IAppRequest> {
        return this.http.post<any>(this.serverUrl + this.url + '/get_new_item', data, this._httpOptions);
    }
}
